// Authenticated user's own profile + password.
import axios from "axios";
import { Modal, message } from "antd";
import { getErrorMessage } from "../utils/errorMessages";

const PREFIX = process.env.REACT_APP_BASE_URL + "/api/accounts";

export async function getProfile() {
  try {
    const res = await axios.get(PREFIX + "/profile/");
    return res.data;
  } catch (error) {
    Modal.error({
      title: "Failed to load profile",
      content: getErrorMessage(error),
    });
    throw error;
  }
}

export async function updateProfile(data) {
  try {
    const res = await axios.patch(PREFIX + "/profile/", data);
    message.success("Profile updated.");
    return res.data;
  } catch (error) {
    const detail = error?.response?.data
      ? typeof error.response.data === "string"
        ? error.response.data
        : Object.entries(error.response.data)
            .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`)
            .join("\n")
      : getErrorMessage(error);
    Modal.error({ title: "Failed to update profile", content: detail });
    throw error;
  }
}

export async function uploadProfilePhoto(file) {
  try {
    const fd = new FormData();
    fd.append("photo", file);
    const res = await axios.patch(PREFIX + "/profile/", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    message.success("Photo updated.");
    return res.data;
  } catch (error) {
    const data = error?.response?.data;
    let detail = "";
    if (data && typeof data === "object") {
      detail =
        data.photo ||
        data.detail ||
        data.message ||
        Object.entries(data)
          .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`)
          .join("; ");
    } else if (typeof data === "string") {
      detail = data;
    }
    Modal.error({
      title: "Failed to upload photo",
      content: detail || getErrorMessage(error),
    });
    throw error;
  }
}

export async function changePassword(old_password, new_password, new_password2) {
  try {
    const res = await axios.post(PREFIX + "/change_password/", {
      old_password,
      new_password,
      new_password2,
    });
    return res.data;
  } catch (error) {
    // Re-throw without a Modal — the page renders inline field errors.
    throw error;
  }
}
